import { useInfiniteQuery, useQuery } from "react-query";
import axiosInstance from "../../services/axiosInstance";
import ProductService from "../../services/productService";
interface IFetchSearchProduct {
  city?: number | null;
  category?: number | null;
  subCategory?: number | null;
  keyword?: string | null;
  type?: string | null;
  pageSize?: number | null;
  orderingKey?: string | null;
}
const fetchSearchProducts = async (
  props: {
    pageIndex: number;
  } & IFetchSearchProduct,
) => {
  const response = await axiosInstance.get<
    ApiResponse<PageResult<ProductDetailResponse>>
  >(`/products/list`, {
    params: {
      ...props,
      pageSize: props.pageSize ?? 12,
    },
  });
  return response.data.result;
};

export const useSearchProduct = (props: IFetchSearchProduct) => {
  return useInfiniteQuery<PageResult<ProductDetailResponse>>(
    ["product", props],
    ({ pageParam }) =>
      fetchSearchProducts({
        ...props,
        pageIndex: pageParam ?? 0,
      }),
    {
      getNextPageParam: (lastPage, pages) =>
        lastPage.pageIndex >= lastPage.totalPages - 1
          ? undefined
          : pages.length,
    },
  );
};

export const useGetProductById = ({ id }: { id: number }) =>
  useQuery({
    queryKey: ["product", id],
    queryFn: () => ProductService.getProductById(id),
    enabled: !!id,
    refetchOnWindowFocus: false,
  });

export const useGetProductBySlug = ({ slug }: { slug: string }) =>
  useQuery({
    queryKey: ["product", slug],
    queryFn: () => ProductService.getProductBySlug(slug),
    enabled: !!slug,
    refetchOnWindowFocus: false,
  });

export const useGet3rdProductAvailability = ({
  productId,
  month,
  quantity,
  bookingId,
  isLinked3rdParty,
}: {
  productId: number;
  month: string;
  quantity: number;
  bookingId: string;
  isLinked3rdParty: boolean;
}) =>
  useQuery({
    queryKey: ["productAvailability", productId, quantity, month],
    queryFn: () =>
      isLinked3rdParty
        ? ProductService.get3rdProductAvailability({
            productId,
            month,
            quantity,
            bookingId,
          })
        : ProductService.getProductAvailability({
            productId,
            month,
          }),
    enabled: !!productId && !!quantity && !!month,
    refetchOnWindowFocus: false,
  });

export const useGetProductList = ({
  city,
  category,
  subCategory,
  keyword,
  type,
  excludeIds,
  commonSort,
}: {
  city?: string;
  category?: string;
  subCategory?: string;
  keyword?: string;
  type?: string;
  excludeIds?: string;
  commonSort?: string;
}) =>
  useQuery(
    [
      "products-list",
      type,
      city,
      category,
      subCategory,
      keyword,
      excludeIds,
      commonSort,
    ],
    async () => {
      const result = await ProductService.fetchProductList({
        city,
        category,
        subCategory,
        keyword,
        type,
        excludeIds,
        commonSort,
      });
      return result?.data || [];
    },
  );

export const useGetProductList2 = ({
  city,
  category,
  subCategory,
  keyword,
  type,
  excludeIds,
  commonSort,
  pageIndex = 0,
  pageSize = 12,
}: {
  city?: string;
  category?: string;
  subCategory?: string;
  keyword?: string;
  type?: string;
  excludeIds?: string;
  commonSort?: string;
  pageSize?: number;
  pageIndex?: number;
}) =>
  useQuery(
    [
      "products-list",
      type,
      city,
      category,
      subCategory,
      keyword,
      excludeIds,
      commonSort,
      pageSize,
      pageIndex,
    ],
    async () => {
      const result = await ProductService.fetchProductList2({
        city,
        category,
        subCategory,
        keyword,
        type,
        excludeIds,
        commonSort,
        pageSize,
        pageIndex,
      });
      return result;
    },
  );
